var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"hypothesis-group"},[_vm._v("\n  "+_vm._s((_vm.hypothesis_group != '' ? _vm.hypothesis_group_name : 'Public'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }